import React, {
  // useContext,
  useEffect,
  useMemo,
  useState
} from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import Button from '../../../../../../components/Button'

import useLineItemDetails from '../hooks/useLineItemDetails'

import {
  FORMAT_CAROUSEL,
  // FORMAT_EXISTING_POST,
  FORMAT_OPTION,
  FORMAT_SINGLE
} from '../../../fields'

// import { AdFacebookCreateContext } from '../../../../formsContexts/AdFacebookCreateFormContextProvider'
// import { LEAD_GENERATION } from '../../../../../../constants/campaigns'

import useStyles from '../../../../../../styles/common/stepForms'

const AdCreateRouteSelector = ({ manageStepFormRoutes, handleStepChange }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { selectedRoute, handleSelectRoute, routeWasSelected } = manageStepFormRoutes
  // chooseRoute just handle the UI and selectedRoute manage actual route
  const [chooseRoute, setChooseRoute] = useState(selectedRoute)

  // const { lineItem } = useContext(AdFacebookCreateContext)
  // const { objective: lineItemObjective } = lineItem

  const { isCarouselAdAllowed, isVideoViews } = useLineItemDetails()

  const newsFeedAdRouteTitle = useMemo(
    () => (isVideoViews ? 'A newsfeed ad with a single  video' : 'A newsfeed ad with a single image or video'),
    [isVideoViews]
  )

  const showCarouselRoute = useMemo(() => isCarouselAdAllowed && !isVideoViews, [isCarouselAdAllowed, isVideoViews])

  // const showExistingPostRoute = useMemo(
  //   () =>
  //     // Hide the Existing post option if the line item objective = lead_generation
  //     lineItemObjective !== LEAD_GENERATION,
  //   [lineItemObjective]
  // )

  const handleContinue = () => {
    if (selectedRoute === chooseRoute) {
      // route wasn't change
      handleStepChange()
    } else {
      // selected new route
      handleSelectRoute(chooseRoute)
    }
  }

  useEffect(() => {
    routeWasSelected && handleStepChange()
    // eslint-disable-next-line
  }, [])

  // The answers to this question will define which route the user takes (Route A, Route B or Route C)
  return (
    <div>
      <div className={classes.stepTitle}>{t('Which type of ad do you want to create?')}</div>
      <div className={classes.stepBody}>
        <RadioBlock
          setFieldValue={(fieldName, route) => setChooseRoute(route)}
          id="radio_format_single"
          name={FORMAT_OPTION}
          value={FORMAT_SINGLE}
          selectedValue={chooseRoute}
          label={t(newsFeedAdRouteTitle)}
        />
        {showCarouselRoute && (
          <RadioBlock
            setFieldValue={(fieldName, route) => setChooseRoute(route)}
            id="radio_format_carousel"
            name={FORMAT_OPTION}
            value={FORMAT_CAROUSEL}
            selectedValue={chooseRoute}
            label={t('A newsfeed carousel ad with multiple images or videos')}
          />
        )}
        {/*temorarily commented out*/}
        {/*{showExistingPostRoute && (*/}
        {/*  <RadioBlock*/}
        {/*    setFieldValue={(fieldName, route) => setChooseRoute(route)}*/}
        {/*    id="radio_format_existing_post"*/}
        {/*    name={FORMAT_OPTION}*/}
        {/*    value={FORMAT_EXISTING_POST}*/}
        {/*    selectedValue={chooseRoute}*/}
        {/*    label={t('Existing post')}*/}
        {/*  />*/}
        {/*)}*/}
      </div>
      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </div>
  )
}

export default AdCreateRouteSelector
